import { render } from "./AUTermsAndConditionPage.vue?vue&type=template&id=0de7aa1b&scoped=true&ts=true"
import script from "./AUTermsAndConditionPage.vue?vue&type=script&lang=ts"
export * from "./AUTermsAndConditionPage.vue?vue&type=script&lang=ts"

import "./AUTermsAndConditionPage.vue?vue&type=style&index=0&id=0de7aa1b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de7aa1b"]])

export default __exports__